import { createApiEffect } from '@/features/api/common/create-api-effect'
import { GetGroupType } from '@/features/api/groups/types'

export const getGroupIdFx = createApiEffect<string, GetGroupType>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/user-app/groups/${id}/`,
  }),
})
